import { render, staticRenderFns } from "./DialogEvaluacion.vue?vue&type=template&id=20454746"
import script from "./DialogEvaluacion.vue?vue&type=script&lang=js"
export * from "./DialogEvaluacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports